import { ImageViewModal, type TypeImageItemExtractor } from '~/components/common';

import type { TypeReceiveStatusDetailIssueImage } from '~/types/receive.types';

const ReceiveStatusIssueImageModal = ({
  imageList,
  isOpen,
  onClose,
}: {
  imageList: TypeReceiveStatusDetailIssueImage[];
  isOpen: boolean;
  onClose: () => void;
}) => {
  const extractor: TypeImageItemExtractor<TypeReceiveStatusDetailIssueImage> = {
    getId: (item) => item.fileId,
    getUrl: (item) => item.filePath,
  };

  const getAltText = (_: TypeReceiveStatusDetailIssueImage, index: number) => `이슈 이미지 ${index + 1}`;

  return (
    <ImageViewModal
      title="이슈 이미지"
      imageList={imageList}
      extractor={extractor}
      isOpen={isOpen}
      onClose={onClose}
      getAltText={getAltText}
    />
  );
};

export default ReceiveStatusIssueImageModal;
